import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import Form from 'react-bootstrap/Form';
import { ReactComponent as CloseIcon } from '../../design-system/design_system/assets/icons/system/close.svg';
import OkIcon from '../../design-system/design_system/assets/icons/components/notifications/ok.svg';
import { FeedbackValidator } from '../feedback/FeedbackValidator';
import { commentGTM, emailGTM } from '../../common/gtm/feedback';
import { configuredAEMUrl } from '../../utils/AEMUtils';

const FeedbackRatingAEM = (props) => {
  const { closeFeedBack, feedbackContent } = props;

  const items = get(feedbackContent, ':items.root.:items');
  const feedbackClickToChat = find(items, { componentname: 'feedback' });

  const [comment, setComment] = useState(false);
  const [next, setNext] = useState(false);
  const [thanksMsg, setThanksMsg] = useState(false);
  const [minComment, setMinComment] = useState(false);
  const [selectedEmoji, setselectedEmoji] = useState('');
  const [getCommentTextLength, setGetCommentTextLength] = useState(0);
  const [emailOption, setEmailOption] = useState(false);
  const [selectedEmojiOnhover, setselectedEmojiOnHover] = useState('');

  const closeFeedBackHandeler = (value) => {
    setComment(false);
    setNext(false);
    setThanksMsg(false);
    setMinComment(false);
    setselectedEmoji('');
    setGetCommentTextLength(0);
    setEmailOption(false);
    closeFeedBack(value);
  };


  const selectedEmojiArray = (ratingValue) => {
    const emojis = [
      { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[0].hoverImage')), alt: get(feedbackClickToChat, 'emojis[0].emojiAlt'), rating: 1 },
      { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[1].hoverImage')), alt: get(feedbackClickToChat, 'emojis[1].emojiAlt'), rating: 2 },
      { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[2].hoverImage')), alt: get(feedbackClickToChat, 'emojis[2].emojiAlt'), rating: 3 },
      { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[3].hoverImage')), alt: get(feedbackClickToChat, 'emojis[3].emojiAlt'), rating: 4 },
      { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[4].hoverImage')), alt: get(feedbackClickToChat, 'emojis[4].emojiAlt'), rating: 5 },
    ];
    const getEmoji = emojis.find(each => each.rating === ratingValue);
    return getEmoji.icon;
  };

  const [errorObject, seterrorObject] = useState({});
  const emojiArray = [
    { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[0].defaultImage')), alt: get(feedbackClickToChat, 'emojis[0].emojiAlt'), rating: 1 },
    { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[1].defaultImage')), alt: get(feedbackClickToChat, 'emojis[1].emojiAlt'), rating: 2 },
    { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[2].defaultImage')), alt: get(feedbackClickToChat, 'emojis[2].emojiAlt'), rating: 3 },
    { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[3].defaultImage')), alt: get(feedbackClickToChat, 'emojis[3].emojiAlt'), rating: 4 },
    { icon: configuredAEMUrl(get(feedbackClickToChat, 'emojis[4].defaultImage')), alt: get(feedbackClickToChat, 'emojis[4].emojiAlt'), rating: 5 },
  ];

  const setCommentAndselectedHover = (selectedEmojis) => {
    setComment(true);
    setselectedEmoji(selectedEmojis);
    setTimeout(() => {
      const input = document.getElementById('experience');
      input.focus();
    }, 200);
  };

  const setFocusOnThankYou = () => {
    setTimeout(() => {
      const thankYou = document.getElementById('thank-you-msg');
      thankYou.tabIndex = 0;
      thankYou.focus();
      thankYou.tabIndex = -1;
    }, 200);
  };

  const handleSend = () => {
    const emailValue = document.getElementById('email').value;
    const emailRegex = FeedbackValidator(emailValue, get(feedbackClickToChat, 'emailerror'));
    if (Object.keys(emailRegex).length > 0) {
      setThanksMsg(false);
      seterrorObject(emailRegex);
    } else {
      emailGTM(emailValue);
      setThanksMsg(true);
      seterrorObject({});
      setFocusOnThankYou();
    }
  };

  const getNextSection = (value) => {
    setNext(value);
    const experience = document.getElementById('experience').value;
    commentGTM(selectedEmoji, experience);
  };

  const onSkipButtonClick = () => {
    setThanksMsg(true);
    setFocusOnThankYou();
  };

  return (
    <section className="px-0 feedback-options shadow-2 bg-white rounded" data-testid="feedback-rating">
      <section className="rating-card p-3">
        <Button variant="ghost" aria-label={get(feedbackClickToChat, 'ariaLabel')} className="position-absolute p-0 close-icon mb-4" onClick={() => closeFeedBackHandeler(false)} data-testid="rating-card-id">
          <CloseIcon className="svg-fill-black ds-svg-icon" />
        </Button>
        <section className={thanksMsg ? 'text-center mb-2' : 'text-center mb-3 pt-5'}>
          {!comment && (
          <p className="p-3 mb-0 font-weight-bold text-center">
            {get(feedbackClickToChat, 'title')}
          </p>
          )}
          {!next && (
          <div className="d-flex">
            {
            emojiArray.map((each, index) => (
              <React.Fragment key={each.rating}>
                <Button
                  variant="ghost"
                   // disabled={comment}
                  className="p-0"
                  onClick={() => setCommentAndselectedHover(each.rating)}
                  onMouseOut={() => {
                    setselectedEmojiOnHover('');
                  }
                  }
                  onFocus={() => setselectedEmojiOnHover(each.rating)}
                  onMouseOver={() => setselectedEmojiOnHover(each.rating)}
                  onBlur={() => {
                    setselectedEmojiOnHover('');
                  }
                  }
                  data-testid={`selected-emogi-${index}`}
                >

                  {selectedEmoji === each.rating || selectedEmojiOnhover === each.rating ? <img src={selectedEmojiArray(each.rating)} className="px-1" alt={each.alt} />
                    : <img src={each.icon} className="px-1" alt={each.alt} />}
                </Button>

              </React.Fragment>
            ))
          }
          </div>
          )}
        </section>
        {(comment && !next) && (
        <React.Fragment>
          <Form.Label
            className={
              `float-right heading ${parseInt(getCommentTextLength, 10) === parseInt(get(feedbackClickToChat, 'characterlimit'), 10) && 'text-danger'}`
            }
          >
            {getCommentTextLength}
              /
            {get(feedbackClickToChat, 'characterlimit')}
          </Form.Label>
          <Form.Control
            as="textarea"
            data-testid="feedback-text-area"
            maxLength={get(feedbackClickToChat, 'characterlimit')}
            id="experience"
            placeholder={get(feedbackClickToChat, 'feedbackplaceholder')}
            className="px-2 font-weight-normal"
            rows="3"
            required
            onChange={(e) => {
              if (e.target.value.length > 0) {
                setMinComment(true);
                setGetCommentTextLength(e.target.value.length);
              } else {
                setMinComment(false);
                setGetCommentTextLength(e.target.value.length);
              }
            }}
          />
          <Button
            variant="primary"
            className="mt-3 w-100 py-2 text-white feedback-btn-text-aem"
            onClick={() => getNextSection(true)}
            disabled={!minComment}
            data-testid="next-feedback-button"
          >
            {get(feedbackClickToChat, 'feedbackcta')}
          </Button>
        </React.Fragment>
        )}
        {console.log('next', next, thanksMsg)}
        {(next && !thanksMsg) && (
        <React.Fragment>
          <section className="content-body">
            <Form.Control
              type="email"
              required
              id="email"
              placeholder={get(feedbackClickToChat, 'emailplaceholder')}
              className={`px-2 font-weight-normal mt-5 ${Object.keys(errorObject).length > 0 && 'error-text-box'}`}
              rows="1"
              onChange={(e) => {
                seterrorObject({});
                if (e.target.value.length > 0) {
                  setEmailOption(true);
                } else {
                  setEmailOption(false);
                }
              }}
              onFocus={() => seterrorObject({})}
              data-testid="EmailPlaceholderText-chat"
            />
          </section>
          <span className="error-style" aria-live="polite">
            {Object.keys(errorObject).length > 0 && get(errorObject, 'feedbackEmail')}
          </span>
          <Button variant="ghost" className="mt-2 w-100 py-2" onClick={() => onSkipButtonClick()} data-testid="skip-feedback">
            {get(feedbackClickToChat, 'skiplabel')}
          </Button>
          <Button
            variant="primary"
            className="mt-2 w-100 py-2 text-white feedback-btn-text-aem"
            onClick={() => handleSend()}
            disabled={!emailOption}
            data-testid="send-feedback"
          >
            {get(feedbackClickToChat, 'emailcta')}
          </Button>
        </React.Fragment>
        )}
        {thanksMsg && (
        <div className="text-center">
          <img src={OkIcon} alt="" />
          <p className="my-2 font-weight-bold" id="thank-you-msg">
            {get(feedbackClickToChat, 'thankyou')}
          </p>
        </div>
        )}
      </section>
    </section>
  );
};

FeedbackRatingAEM.propTypes = {
  closeFeedBack: PropTypes.func.isRequired,
  feedbackContent: PropTypes.instanceOf(Object).isRequired,
};


const mapStateToProps = state => ({
  feedbackContent: state.CommonReducer.feedbackContent,
});
export default connect(
  mapStateToProps,
  null,
)(FeedbackRatingAEM);
